import React from "react";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const IconCredits = ({ width = "24px", height = "24px", fill = "#000" }: Props) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={fill} strokeWidth="2"/>
    <path d="M8 12h8M12 8v8" stroke={fill} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export default IconCredits;